<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-white">
    <div class="w-full max-w-sm mx-auto">
      <!-- 错误图标和标题 -->
      <div class="flex flex-col items-center mb-8">
        <div
          class="flex items-center justify-center w-20 h-20 mb-6 bg-red-50 border-2 border-red-200 rounded-full"
        >
          <AlertTriangle :size="40" class="text-red-500" />
        </div>
        <h1 class="text-xl font-bold text-gray-900 text-center mb-4">
          应用初始化失败
        </h1>
        <div class="text-sm leading-relaxed text-center text-gray-600 px-4">
          <p class="mb-2">
            您好,
            当前应用初始化发生认证故障，无法继续，您可以点击下方按钮重新尝试或者退出应用，为您带来的不便敬请谅解！
          </p>
        </div>
      </div>

      <!-- 操作按钮 -->
      <div class="space-y-3">
        <Button
          type="primary"
          size="large"
          class="w-full"
          @click="handleRefresh"
        >
          <RefreshCw :size="16" class="mr-2" />
          重新尝试
        </Button>

        <Button
          type="secondary"
          size="large"
          class="w-full"
          @click="handleExit"
        >
          <LogOut :size="16" class="mr-2" />
          退出应用
        </Button>
      </div>

      <!-- 版本信息 -->
      <div class="mt-8 text-xs text-center text-gray-400">
        版本 {{ version }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { AlertTriangle, RefreshCw, LogOut } from 'lucide-vue-next'
import Button from '../Button/index.vue'
import { useAppStore } from '@/hooks/useAppStore'

const { appState } = useAppStore()
const version = appState.config.version

const handleRefresh = () => {
  window.location.reload()
}

const handleExit = () => {
  // 调用HXE API退出应用
  window.hxe?.exit?.()
}
</script>
